import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebase';
import ChatGPTInterface from '../componentes/ChatGPTInterface';
import { FaArrowLeft, FaHome } from 'react-icons/fa';

const TestChatGPT = () => {
  const navigate = useNavigate();
  const [chatId] = useState('test-chat-' + Date.now()); // Genera un ID único para pruebas

  if (!auth.currentUser) {
    return (
      <div style={{ 
        padding: '2rem', 
        textAlign: 'center', 
        maxWidth: '400px', 
        margin: '2rem auto' 
      }}>
        <h2>Acceso Restringido</h2>
        <p>Debes iniciar sesión para usar el chat con ChatGPT.</p>
        <Link to="/login" style={{ 
          color: '#1a73e8', 
          textDecoration: 'none',
          fontWeight: 'bold'
        }}>
          Ir a Login
        </Link>
      </div>
    );
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header with navigation */}
      <div style={{ 
        padding: '1rem', 
        borderBottom: '1px solid #e0e0e0',
        background: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button 
            onClick={() => navigate('/')} 
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: '#f8f9fa',
              border: '1px solid #dee2e6',
              padding: '0.5rem 1rem',
              borderRadius: '6px',
              cursor: 'pointer',
              color: '#495057'
            }}
          >
            <FaArrowLeft />
            Volver al Dashboard
          </button>
          
          <nav style={{ fontSize: '0.9rem', color: '#666' }}>
            <Link to="/" style={{ color: '#1a73e8', textDecoration: 'none' }}>
              <FaHome style={{ marginRight: '0.3rem' }} />
              Inicio
            </Link>
            <span style={{ margin: '0 0.5rem' }}>/</span>
            <span>Test ChatGPT</span>
          </nav>
        </div>

        <div style={{ fontSize: '0.9rem', color: '#666' }}>
          Usuario: {auth.currentUser?.email}
        </div>
      </div>

      {/* Chat Interface */}
      <div style={{ flex: 1, padding: '1rem', background: '#f5f5f5' }}>
        <ChatGPTInterface 
          chatId={chatId} 
          clienteId={auth.currentUser?.uid} 
        />
      </div>

      {/* Info footer */}
      <div style={{ 
        padding: '0.5rem 1rem',
        background: '#fff3cd',
        borderTop: '1px solid #ffeaa7',
        fontSize: '0.85rem',
        color: '#856404',
        textAlign: 'center'
      }}>
        💡 Esta es una versión de prueba del chat con ChatGPT. Los mensajes se guardan en Firebase.
      </div>
    </div>
  );
};

export default TestChatGPT;